import { render, staticRenderFns } from "./client-meetings-list.vue?vue&type=template&id=32dd2dd1&scoped=true"
import script from "./client-meetings-list.vue?vue&type=script&lang=js"
export * from "./client-meetings-list.vue?vue&type=script&lang=js"
import style0 from "./client-meetings-list.vue?vue&type=style&index=0&id=32dd2dd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dd2dd1",
  null
  
)

export default component.exports